import config from '../../config'
import { useTranslation } from '@/hooks/useTranslation'
import {
	LegalP,
	LegalPageLayout,
	LegalSection,
	useLegalUpdatedDate,
} from '@/components/legal/LegalPageLayout'

const LegalNotice = () => {
	const { t } = useTranslation()
	const date = useLegalUpdatedDate()

	return (
		<LegalPageLayout
			title={t('legalNotice.title')}
			lastUpdated={t('legal.lastUpdated', { date })}
		>
			<LegalSection title={t('legalNotice.publisherTitle')}>
				<LegalP>{t('legalNotice.publisherIntro')}</LegalP>
				<div className="bg-gray-50 rounded-xl p-6 border border-gray-100">
					<p className="text-gray-600">{config.companyName}</p>
					<p className="text-gray-600">{config.companyAddress}</p>
					<p className="text-gray-600">
						{t('legalNotice.shareCapital')} {config.companyShareCapital}
					</p>
					<p className="text-gray-600">
						{t('legalNotice.siret')} {config.companySiret}
					</p>
					<p className="text-gray-600">
						{t('legalNotice.rcs')} {config.companyRcs}
					</p>
					<p className="text-gray-600">
						{t('legalNotice.vatNumber')} {config.companyVatNumber}
					</p>
					<p className="text-gray-600">
						{t('legalNotice.publicationDirector')} {config.publicationDirector}
					</p>
					<p className="text-gray-600 mt-2">
						{t('legal.email')}{' '}
						<a
							href={`mailto:${config.supportEmail}`}
							className="text-primary hover:text-primary/90 font-medium"
						>
							{config.supportEmail}
						</a>
					</p>
					<p className="text-gray-600">
						{t('legalNotice.website')}{' '}
						<a
							href={config.websiteUrl}
							className="text-primary hover:text-primary/90 font-medium"
						>
							{config.websiteUrl}
						</a>
					</p>
				</div>
			</LegalSection>

			<LegalSection title={t('legalNotice.hostingTitle')}>
				<LegalP>{t('legalNotice.hostingContent')}</LegalP>
				<div className="bg-gray-50 rounded-xl p-6 border border-gray-100 mt-4">
					<p className="font-medium text-gray-900">Vercel Inc.</p>
					<p className="text-gray-600">
						440 N Barranca Ave #4133, Covina, CA 91723, United States
					</p>
					<a
						href="https://vercel.com/legal"
						target="_blank"
						rel="noopener noreferrer"
						className="text-primary hover:text-primary/90 font-medium"
					>
						vercel.com/legal
					</a>
					<p className="font-medium text-gray-900 mt-4">Supabase Pte. Ltd.</p>
					<p className="text-gray-600">
						65 Chulia Street #38-02/03, OCBC Centre, Singapore 049513
					</p>
					<a
						href="mailto:legal@supabase.com"
						className="text-primary hover:text-primary/90 font-medium"
					>
						legal@supabase.com
					</a>
				</div>
			</LegalSection>

			<LegalSection title={t('legalNotice.contactTitle')}>
				<LegalP>
					{t('legalNotice.contactContent', {
						supportEmail: config.supportEmail,
					})}
				</LegalP>
			</LegalSection>
		</LegalPageLayout>
	)
}

export default LegalNotice
